import { font, colors, devices } from '../../config/theme'
import { widthHeight100 } from '../../utils/jss-utils'

const style = {}

style.base = {
  overflowX: 'hidden',
  padding: '5px',
  ...widthHeight100,
  '& input': {
    fontSize: '26px !important'
  }
}

export default style
